"use strict";

exports.__esModule = true;
exports.default = getFileType;
var _getFileNameAndExtension = _interopRequireDefault(require("./getFileNameAndExtension.js"));
var _mimeTypes = _interopRequireDefault(require("./mimeTypes.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getFileType(file) {
  var _getFileNameAndExtens;
  if (file.type) return file.type;
  var fileExtension = file.name ? (_getFileNameAndExtens = (0, _getFileNameAndExtension.default)(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
  if (fileExtension && fileExtension in _mimeTypes.default) {
    // else, see if we can map extension to a mime type
    return _mimeTypes.default[fileExtension];
  }
  // if all fails, fall back to a generic byte stream type
  return 'application/octet-stream';
}